import React from 'react';
import { Button, Tabs, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

export interface SkillStudioSectionOption {
    key: string;
    label: string;
    icon?: React.ReactNode;
    content: React.ReactNode;
}

export interface SkillStudioProps {
    sections: SkillStudioSectionOption[];
    onBack: () => void;
    title?: string;
    defaultActiveKey?: string;
    activeKey?: string;
    onSectionChange?: (key: string) => void;
    containerStyle?: React.CSSProperties;
}

const SkillStudio: React.FC<SkillStudioProps> = ({
    sections,
    onBack,
    title = 'Evaluation',
    defaultActiveKey,
    activeKey,
    onSectionChange,
    containerStyle,
}) => {
    const tabItems = sections.map((section) => ({
        key: section.key,
        label: (
            <span>
                {section.icon} {section.label}
            </span>
        ),
        children: section.content,
    }));

    return (
        <div
            style={{
                padding: 24,
                background: '#fff',
                height: '100%',
                overflowY: 'auto',
                ...containerStyle,
            }}
        >
            <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
                <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} />
                <Title level={4} style={{ margin: 0 }}>
                    {title}
                </Title>
            </div>
            <Tabs
                items={tabItems}
                defaultActiveKey={defaultActiveKey}
                activeKey={activeKey}
                onChange={onSectionChange}
            />
        </div>
    );
};

export default SkillStudio;
